import { useLayoutEffect, useSyncExternalStore } from 'react';

/*
 * Общие слои приложения — список тостов (`Notifications`) и окна сообщений (`ModalMessages`) — по одному в его корне,
 * а не в каждой области. Пока открыта область со своей темой (дизайнер маршрутов), они показываются в её хосте
 * порталов и получают её роли, палитру и переменные Mantine — как окна и подсказки пакета в ней. Открытая последней —
 * сверху.
 */
const hosts: HTMLElement[] = [];
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};
const currentHost = () => hosts.at(-1);
const emitChange = () => listeners.forEach((listener) => listener());

/**
 * Тосты и окна сообщений приложения — в `host`, пока смонтирован вызвавший: область со своей темой отдаёт свой хост
 * порталов (`useAppPortalHost(usePortalTarget())`). Хост — в body и без своего слоя: тосты и окна — `position: fixed`
 * со своим z-index. Без хоста ничего не меняется.
 */
export const useAppPortalHost = (host: HTMLElement | null | undefined) => {
    useLayoutEffect(() => {
        if (!host) return undefined;
        hosts.push(host);
        emitChange();
        return () => {
            const index = hosts.lastIndexOf(host);
            if (index >= 0) hosts.splice(index, 1);
            emitChange();
        };
    }, [host]);
};

/** Хост общих слоёв приложения: область, открытая последней; `undefined` — их место по умолчанию */
export const useAppPortalHostTarget = () => useSyncExternalStore(subscribe, currentHost, () => undefined);
